import React, { Component } from 'react'
import { auth } from '../../firebase'
import { signInWithEmailAndPassword } from 'firebase/auth'
import './Login.css'
import logoStadium from '../../images/logo_stadium.png'
import { ControlEmail, ControlPassword } from '../forms/Controls'
import { StatusError } from '../forms/Status'
import { ButtonPrimary } from '../components/Buttons'

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      error: null,
      status: '',
      loading: false
    }
    this.handleEmail = this.handleEmail.bind(this)
    this.handlePassword = this.handlePassword.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleEmail (ev) {
    this.setState({
      email: ev.target.value,
      status: '',
      error: null
    })
  }
  handlePassword (ev) {
    this.setState({
      password: ev.target.value,
      status: '',
      error: null
    })
  }
  handleSubmit (ev) {
    ev.preventDefault()
    if (this.state.email === '') {
      this.setState({
        error: 'email',
        status: '¡No olvides tu email!'
      })
      // eslint-disable-next-line
    } else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email))) {
      this.setState({
        error: 'email',
        status: 'Revisa tu email'
      })
    } else if (this.state.password === '') {
      this.setState({
        error: 'password',
        status: '¡No olvides tu contraseña!'
      })
    } else {
      this.setState({
        loading: true
      })
      signInWithEmailAndPassword(auth, this.state.email, this.state.password)
      .then(() => {
        this.setState({
          loading: false
        })
      })
      .catch((err) => {
        switch (err.code) {
          case 'auth/wrong-password':
            this.setState({
              error: 'password',
              status: 'Contraseña incorrecta',
              loading: false
            })
            break
          case 'auth/invalid-email':
            this.setState({
              error: 'email',
              status: 'Email inválido',
              loading: false
            })
            break
          case 'auth/user-not-found':
            this.setState({
              error: true,
              status: 'Usuario no encontrado',
              loading: false
            })
            break
          case 'auth/user-disabled':
            this.setState({
              error: true,
              status: 'Cuenta deshabilitada',
              loading: false
            })
            break
          default:
            this.setState({
              error: true,
              status: err.code,
              loading: false
            })
        }
      })
    }
  }
  render () {
    return (
      <div className='login'>
        <div>
          <h1 className='login__title'>
            <img src={logoStadium} alt='Stadium Admin' />
          </h1>
          <h2>Administrador de quinielas</h2>
          <p>Inicia sesión para empezar:</p>
          <form>
            <ControlEmail
              value={this.state.email}
              placeholder='Email'
              onChange={this.handleEmail}
              error={this.state.error === 'email'}
            />
            <ControlPassword
              placeholder='Password'
              value={this.state.password}
              onChange={this.handlePassword}
              error={this.state.error === 'password'}
            />
            {this.state.error ? <StatusError>{this.state.status}</StatusError> : null }
            <ButtonPrimary
              onClick={this.handleSubmit}
              loading={this.state.loading}
              type='submit'
              label='Entrar'
            />
          </form>
          <p><small>&copy; {new Date().getFullYear()} Stadium.</small></p>
        </div>
      </div>
    )
  }
}

export default Login
